import { fetch } from '@financial-tool/fetch';
import { InvitationStatus } from '../../user-session/types/user';
import { Invitation } from '../types';

export default function revokeInvitation(invitationId: string) {
  return fetch.patch<Invitation>(`/invitations/${invitationId}`, {
    status: InvitationStatus.REVOKED,
  });
}
